// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"daf68143","455":"15d47cd4","977":"ea6d92c7"}[chunkId] + ".chunk.js";
};